/* global toastr */
import React from 'react'
import Swal from 'sweetalert2'
import { wrapView, request, format_date } from '../smart_bps/lib/utils'
import { stateToPropsSigur } from '../lib/stateToPropsSigur'
import { PROJECT_NAME } from './constants'
import { SigurModelView } from '../lib/SigurModelView'
import { Panel } from '../smart_bps/lib/components'
import {formatDateTime} from '../lib/utils'
import { initSelect2InModal, destroySelect2InModal, syncSelect2InModal } from '../lib/select2Modal'
import { Input } from '../smart_bps/lib/attr_input'

class ModelView extends SigurModelView {
  isNewCard() {
    return this.object_id === 0
  }

  // Для новой карточки скрываем кнопку "Редактировать все".
  renderContentLeftActionRightItems() {
    if (this.isNewCard()) {
      return []
    }
    return super.renderContentLeftActionRightItems()
  }

  renderDeleteConfirmModal() {
  if (!this.state.showDeleteModal) return null

  function canDeleteModalContent() {
    return (
      <div>
        <div className="modal-body sigur-delete-confirm-modal__body">
          <span className="sigur-delete-confirm-modal__icon ti ti-alert-triangle" aria-hidden="true" />
          <p className="sigur-delete-confirm-modal__text mb-0">
            Это действие нельзя будет отменить. Вы уверены, что хотите удалить карточку?
          </p>
        </div>
        <div className="modal-footer px-3">
          <button type="button" className="btn btn-primary p-2 me-1" onClick={this.confirmDeleteAndClose}>
            Удалить
          </button>
          <button type="button" className="btn btn-secondary p-2 me-1" onClick={this.closeDeleteConfirm}>
            Отменить
          </button>
        </div>
      </div>
    )
  }

  function cantDeleteModalContent() {
    return (
      <div>
        <div className="modal-body sigur-delete-confirm-modal__body">
          <span className="sigur-delete-confirm-modal__icon ti ti-alert-triangle" aria-hidden="true" />
          <p className="sigur-delete-confirm-modal__text mb-0">
            Невозможно удалить территорию: существуют связанные с ней заявки
          </p>
        </div>
      </div>
    )
  }

  return (
    <div
      className="sigur-delete-confirm-modal modal fade show"
      style={{ display: 'block' }}
      id="modal_delete_confirm"
      key="delete_confirm_modal"
    >
      <div className="sigur-delete-confirm-modal__backdrop" onClick={this.closeDeleteConfirm} aria-hidden="true" />

      <div className="modal-dialog sigur-delete-confirm-modal__dialog" role="document">
        <div className="modal-content sigur-delete-confirm-modal__content">
          <div className="modal-header sigur-delete-confirm-modal__header">
            <h5 className="modal-title sigur-delete-confirm-modal__title">
              {this.getDeleteConfirmTitle()}
            </h5>

            <button
              type="button"
              className="btn-close"
              onClick={this.closeDeleteConfirm}
              aria-label="Закрыть"
            />
          </div>

          {this.state.can_delete_document
            ? canDeleteModalContent.call(this)
            : cantDeleteModalContent.call(this)}
        </div>
      </div>
    </div>
  )
}

  collectDocTabs() {
    const tabs = []
    let first_tab
    this.props.form_schema.forEach((item) => {
      if (first_tab === undefined) first_tab = item[0]
      if (!tabs.includes(item[0]) && (item[0] !== 'Текущие доступы' || this.state.object_id)) {
        tabs.push(item[0])
      }
    })
    return { tabs, first_tab }
  }

  constructor(props) {
    super(props)
    this.state = {
      ...this.state,
      // Режимы
      territoryModes: [],
      showModesModal: false,
      modalModes: [],
      modalModesPage: 1,
      modalModesTotalPages: 1,
      modalModesSelectedIds: new Set(),
      modalModesFilters: {
        level: '',
        name: '',
        description: '',
        start_date_from: '',
        start_date_to: '',
        end_date_from: '',
        end_date_to: '',
      },
      modesFilterOptions: {
        levels: [],
        names: [],
        descriptions: [],
        start_dates: [],
        end_dates: [],
      },
      modalModesAllSelected: false,
      activeAccesses: []
    }

    this.openModesModal = this.openModesModal.bind(this)
    this.closeModesModal = this.closeModesModal.bind(this)
    this.loadTerritoryModes = this.loadTerritoryModes.bind(this)
    this.loadModalModes = this.loadModalModes.bind(this)
    this.loadModesFilterOptions = this.loadModesFilterOptions.bind(this)
    this.handleModesSearch = this.handleModesSearch.bind(this)
    this.handleResetModesFilters = this.handleResetModesFilters.bind(this)
    this.handleSelectAllFoundModes = this.handleSelectAllFoundModes.bind(this)
    this.handleToggleMode = this.handleToggleMode.bind(this)
    this.handleApplyModes = this.handleApplyModes.bind(this)
    this.handleRemoveMode = this.handleRemoveMode.bind(this)
    this.setBodyScrollLock = this.setBodyScrollLock.bind(this)
    this.loadActiveAccesses = this.loadActiveAccesses.bind(this)
    this.modesModalRef = React.createRef()
  }

  // Проверка прав из state.perms
  hasPerm(perm) {
    return this.state.perms && this.state.perms.includes(perm)
  }

  getDeleteConfirmTitle() {
    return 'Удаление территории'
  }

  componentDidMount() {
    super.componentDidMount && super.componentDidMount()
    this.loadActiveAccesses()
  }

  componentWillUnmount() {
    destroySelect2InModal(this.modesModalRef.current)
    this.setBodyScrollLock(false)
  }

  componentDidUpdate(prevProps, prevState) {
    super.componentDidUpdate && super.componentDidUpdate(prevProps, prevState)

    if (prevProps.router_params?.object_id !== this.props.router_params?.object_id) {
      const newId = this.props.router_params?.object_id
      if (newId === 'new' || newId === undefined || parseInt(newId, 10) === 0) {
        this._modesLoaded = false
        this.setState({ territoryModes: [] })
      } else {
        this.loadTerritoryModes()
      }
    }

    if (this.state.object_id && this.state.object_id !== 0 && !this._modesLoaded) {
      this._modesLoaded = true
      this.loadTerritoryModes()
    }
  }

  loadTerritoryModes() {
    const objectId = this.object_id
    if (!objectId || objectId === 0) return
    request({
      method: 'get',
      url: `/api/territories/${objectId}/modes`,
      success: (data) => {
        this.setState({ territoryModes: data.items || [] })
      },
      error: (data) => {
        console.error('Error loading territory modes:', data)
      },
    })
  }

  loadModesFilterOptions() {
    const objectId = this.object_id
    if (!objectId) return
    request({
      method: 'get',
      url: `/api/territories/${objectId}/modes/filter_options`,
      success: (data) => {
        this.setState({
          modesFilterOptions: {
            levels: data.levels || [],
            names: data.names || [],
            descriptions: data.descriptions || [],
            start_dates: data.start_dates || [],
            end_dates: data.end_dates || [],
          },
        })
      },
      error: (data) => {
        console.error('Error loading modes filter options:', data)
      },
    })
  }

  loadModalModes(page = 1) {
    const objectId = this.object_id || 0
    const { modalModesFilters } = this.state
    request({
      method: 'post',
      url: `/api/territories/${objectId}/modes/list`,
      data: {
        page,
        page_size: 10,
        filters: modalModesFilters,
      },
      success: (data) => {
        const items = data.items || []
        if (items.length === 0 && page === 1) {
          toastr.warning('Не найден ни один режим')
        }
        this.setState({
          modalModes: items,
          modalModesPage: data.page || 1,
          modalModesTotalPages: data.total_pages || 1,
        })
      },
      error: (data) => {
        console.error('Error loading modal modes:', data)
      },
    })
  }

  openModesModal() {
    const emptyFilters = {
      level: '',
      name: '',
      description: '',
      start_date_from: '',
      start_date_to: '',
      end_date_from: '',
      end_date_to: '',
    }
    this.setState(
      {
        showModesModal: true,
        modalModesSelectedIds: new Set(),
        modalModesFilters: emptyFilters,
        modalModesAllSelected: false,
      },
      () => {
        this.setBodyScrollLock(true)
        this.loadModesFilterOptions()
        this.loadModalModes(1)
        setTimeout(() => {
          initSelect2InModal(this.modesModalRef.current, (name, val) => {
            this.setState((prev) => ({
              modalModesFilters: { ...prev.modalModesFilters, [name]: val },
            }))
          })
        }, 0)
      }
    )
  }

  closeModesModal() {
    destroySelect2InModal(this.modesModalRef.current)
    this.setBodyScrollLock(false)
    this.setState({ showModesModal: false })
  }

  setBodyScrollLock(locked) {
    if (typeof document === 'undefined') return
    document.body.style.overflow = locked ? 'hidden' : ''
  }

  handleModesSearch() {
    this.setState({ modalModesAllSelected: false })
    this.loadModalModes(1)
  }

  handleResetModesFilters() {
    const emptyFilters = {
      level: '',
      name: '',
      description: '',
      start_date_from: '',
      start_date_to: '',
      end_date_from: '',
      end_date_to: '',
    }
    this.setState({ modalModesFilters: emptyFilters, modalModesAllSelected: false }, () => {
      this.loadModalModes(1)
      setTimeout(() => syncSelect2InModal(this.modesModalRef.current), 0)
    })
  }

  handleSelectAllFoundModes(e) {
    if (e && e.currentTarget) e.currentTarget.blur()
    const { modalModes, modalModesSelectedIds, modalModesAllSelected } = this.state
    if (modalModesAllSelected) {
      const newSelected = new Set()
      modalModes.forEach((m) => {
        if (m.already_added) newSelected.add(m.id)
      })
      this.setState({ modalModesSelectedIds: newSelected, modalModesAllSelected: false })
    } else {
      const newSelected = new Set(modalModesSelectedIds)
      modalModes.forEach((m) => {
        if (!m.already_added) newSelected.add(m.id)
      })
      this.setState({ modalModesSelectedIds: newSelected, modalModesAllSelected: true })
    }
  }

  handleToggleMode(modeId) {
    const { modalModesSelectedIds } = this.state
    const newSelected = new Set(modalModesSelectedIds)
    if (newSelected.has(modeId)) newSelected.delete(modeId)
    else newSelected.add(modeId)
    this.setState({ modalModesSelectedIds: newSelected, modalModesAllSelected: false })
  }

  loadActiveAccesses() {
    const objectId = this.object_id
    if (!objectId || objectId === 0) return null
    request({
      method: 'GET',
      url: `/api/territories/${objectId}/get_active_accesses`,
      success: (data) => {
        this.setState({ activeAccesses: data.items })
      },
      error: (data) => {
        this.setState({ activeAccesses: [] })
      },
    })
  }

  handleApplyModes() {
    const { modalModesSelectedIds } = this.state
    const objectId = this.object_id
    if (modalModesSelectedIds.size === 0) {
      toastr.warning('Не выбран ни один режим')
      return
    }
    if (!objectId || objectId === 0) {
      toastr.warning('Сначала сохраните карточку территории')
      return
    }
    request({
      method: 'post',
      url: `/api/territories/${objectId}/modes/add`,
      data: { mode_ids: Array.from(modalModesSelectedIds) },
      success: () => {
        toastr.success('Режимы добавлены')
        this.closeModesModal()
        this.loadTerritoryModes()
      },
      error: (data) => {
        toastr.error(data.detail || 'Ошибка при добавлении режимов')
      },
    })
  }

  handleRemoveMode(modeId) {
    const objectId = this.object_id
    Swal.fire({
      title: 'Удалить режим?',
      text: 'Режим будет удалён из территории',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Удалить',
      cancelButtonText: 'Отмена',
      focusConfirm: false,
      focusCancel: false,
      customClass: {
        confirmButton: 'btn btn-outline-primary',
        cancelButton: 'btn btn-outline-secondary',
      },
      buttonsStyling: false,
    }).then((result) => {
      if (result.isConfirmed) {
        request({
          method: 'post',
          url: `/api/territories/${objectId}/modes/remove`,
          data: { mode_id: modeId },
          success: () => {
            toastr.success('Режим удалён')
            this.loadTerritoryModes()
          },
          error: (data) => {
            toastr.error(data.detail || 'Ошибка при удалении режима')
          },
        })
      }
    })
  }

  // Блок "Режимы" на вкладке Режимы
  renderModesTable() {
    const { territoryModes } = this.state
    const canAdd = this.hasPerm('add_modes')
    const canRemove = this.hasPerm('remove_modes')

    return (
      <Panel header="Режимы" key="modes_table">
        {canAdd && (
          <div className="mb-3">
            <button className="btn btn-primary btn-sm" onClick={this.openModesModal}>
              Добавить
            </button>
          </div>
        )}
        <div className="table-responsive">
          <table className="table table-sm">
            <thead>
              <tr>
                <th>Уровень режима</th>
                <th>Название</th>
                <th>Описание</th>
                <th>Начало действия</th>
                <th>Окончание действия</th>
                {canRemove && <th style={{ width: '50px' }}></th>}
              </tr>
            </thead>
            <tbody>
              {territoryModes.length === 0 ? (
                <tr>
                  <td
                    colSpan={canRemove ? 6 : 5}
                    className="text-center text-muted"
                  >
                    Нет связанных режимов
                  </td>
                </tr>
              ) : (
                territoryModes.map((m) => (
                  <tr key={m.mode_id}>
                    <td>{m.level != null ? m.level : ''}</td>
                    <td>{m.name || ''}</td>
                    <td>{m.description || ''}</td>
                    <td>{format_date(m.start_date) || ''}</td>
                    <td>{format_date(m.end_date) || ''}</td>
                    {canRemove && (
                      <td>
                        <button
                          className="btn btn-outline-danger btn-xs"
                          onClick={() => this.handleRemoveMode(m.mode_id)}
                          title="Удалить"
                        >
                          <i className="ti ti-trash"></i>
                        </button>
                      </td>
                    )}
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </Panel>
    )
  }

  // (Модальное окно выбора точек доступа удалено — справочник «Точка доступа» снят с поддержки)

  // Модальное окно выбора режимов
  renderModesModal() {
    const {
      showModesModal,
      modalModes,
      modalModesPage,
      modalModesTotalPages,
      modalModesSelectedIds,
      modalModesFilters,
      modesFilterOptions,
      modalModesAllSelected,
    } = this.state

    if (!showModesModal) return null

    return (
      <div
        ref={this.modesModalRef}
        className="modal fade show"
        style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }}
        key="modes_modal"
      >
        <div className="modal-dialog modal-xl">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Доступные к выбору режимы</h5>
              <button type="button" className="btn-close" onClick={this.closeModesModal}></button>
            </div>
            <div className="modal-body" style={{ maxHeight: '70vh', overflowY: 'auto' }}>
              <div className="card mb-3">
                <div className="card-body">
                  <div className="row g-2 align-items-end mb-2">
                    <div className="col-md-4">
                      <label className="form-label">Уровень режима</label>
                      <select
                        name="level"
                        className="form-select form-select-sm js-select2-modal"
                        value={modalModesFilters.level}
                        onChange={(e) =>
                          this.setState({
                            modalModesFilters: { ...modalModesFilters, level: e.target.value },
                          })
                        }
                      >
                        <option value="">Все</option>
                        {modesFilterOptions.levels.map((v) => (
                          <option key={v} value={v}>{v}</option>
                        ))}
                      </select>
                    </div>
                    <div className="col-md-4">
                      <label className="form-label">Название</label>
                      <select
                        name="name"
                        className="form-select form-select-sm js-select2-modal"
                        value={modalModesFilters.name}
                        onChange={(e) =>
                          this.setState({
                            modalModesFilters: { ...modalModesFilters, name: e.target.value },
                          })
                        }
                      >
                        <option value="">Все</option>
                        {modesFilterOptions.names.map((name) => (
                          <option key={name} value={name}>{name}</option>
                        ))}
                      </select>
                    </div>
                    <div className="col-md-4">
                      <label className="form-label">Описание</label>
                      <select
                        name="description"
                        className="form-select form-select-sm js-select2-modal"
                        value={modalModesFilters.description}
                        onChange={(e) =>
                          this.setState({
                            modalModesFilters: { ...modalModesFilters, description: e.target.value },
                          })
                        }
                      >
                        <option value="">Все</option>
                        {modesFilterOptions.descriptions.map((d) => (
                          <option key={d} value={d}>{d}</option>
                        ))}
                      </select>
                    </div>
                  </div>
                  <div className="row g-2 align-items-end">
                    <div className="col-md-4">
                      <label className="form-label">Начало действия</label>
                      <div className="field-range">
                        <Input
                          data_type="date"
                          name="start_date_from"
                          value={modalModesFilters.start_date_from || ''}
                          onChange={(name, val) =>
                            this.setState({
                              modalModesFilters: { ...modalModesFilters, [name]: val || '' },
                            })
                          }
                        />
                        <div className="field-range-divider" aria-hidden />
                        <Input
                          data_type="date"
                          name="start_date_to"
                          value={modalModesFilters.start_date_to || ''}
                          onChange={(name, val) =>
                            this.setState({
                              modalModesFilters: { ...modalModesFilters, [name]: val || '' },
                            })
                          }
                        />
                      </div>
                    </div>
                    <div className="col-md-4">
                      <label className="form-label">Окончание действия</label>
                      <div className="field-range">
                        <Input
                          data_type="date"
                          name="end_date_from"
                          value={modalModesFilters.end_date_from || ''}
                          onChange={(name, val) =>
                            this.setState({
                              modalModesFilters: { ...modalModesFilters, [name]: val || '' },
                            })
                          }
                        />
                        <div className="field-range-divider" aria-hidden />
                        <Input
                          data_type="date"
                          name="end_date_to"
                          value={modalModesFilters.end_date_to || ''}
                          onChange={(name, val) =>
                            this.setState({
                              modalModesFilters: { ...modalModesFilters, [name]: val || '' },
                            })
                          }
                        />
                      </div>
                    </div>
                  </div>
                  <div className="row g-2 mt-1">
                    <div className="col-12">
                      <button className="btn btn-primary btn-sm me-2" onClick={this.handleModesSearch}>
                        Найти
                      </button>
                      <button className="btn btn-secondary btn-sm me-2" onClick={this.handleResetModesFilters}>
                        Сбросить
                      </button>
                      <button type="button" className="btn btn-secondary btn-sm" onClick={this.handleSelectAllFoundModes}>
                        {modalModesAllSelected ? 'Отменить выбор' : 'Выбрать все найденные'}
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              <div className="table-responsive">
                <table className="table table-sm table-hover">
                  <thead>
                    <tr>
                      <th style={{ width: '40px' }}></th>
                      <th>Уровень режима</th>
                      <th>Название</th>
                      <th>Описание</th>
                      <th>Начало действия</th>
                      <th>Окончание действия</th>
                    </tr>
                  </thead>
                  <tbody>
                    {modalModes.map((m) => (
                      <tr key={m.id} className={m.already_added ? 'table-secondary' : ''}>
                        <td>
                          <input
                            type="checkbox"
                            className="form-check-input"
                            checked={modalModesSelectedIds.has(m.id) || m.already_added}
                            disabled={m.already_added}
                            onChange={() => this.handleToggleMode(m.id)}
                          />
                        </td>
                        <td>{m.level != null ? m.level : ''}</td>
                        <td>{m.name || ''}</td>
                        <td>{m.description || ''}</td>
                        <td>{format_date(m.start_date) || ''}</td>
                        <td>{format_date(m.end_date) || ''}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>

              {modalModesTotalPages > 1 && (
                <nav className="mt-3">
                  <ul className="pagination pagination-sm justify-content-center">
                    <li className={`page-item ${modalModesPage === 1 ? 'disabled' : ''}`}>
                      <a
                        className="page-link"
                        href="#"
                        onClick={(e) => {
                          e.preventDefault()
                          if (modalModesPage > 1) this.loadModalModes(modalModesPage - 1)
                        }}
                      >
                        Назад
                      </a>
                    </li>
                    {[...Array(modalModesTotalPages)].map((_, idx) => (
                      <li key={idx} className={`page-item ${modalModesPage === idx + 1 ? 'active' : ''}`}>
                        <a
                          className="page-link"
                          href="#"
                          onClick={(e) => {
                            e.preventDefault()
                            this.loadModalModes(idx + 1)
                          }}
                        >
                          {idx + 1}
                        </a>
                      </li>
                    ))}
                    <li className={`page-item ${modalModesPage === modalModesTotalPages ? 'disabled' : ''}`}>
                      <a
                        className="page-link"
                        href="#"
                        onClick={(e) => {
                          e.preventDefault()
                          if (modalModesPage < modalModesTotalPages) this.loadModalModes(modalModesPage + 1)
                        }}
                      >
                        Вперед
                      </a>
                    </li>
                  </ul>
                </nav>
              )}
            </div>
            <div className="modal-footer">
              <button type="button" className="btn btn-secondary" onClick={this.closeModesModal}>
                Отмена
              </button>
              <button type="button" className="btn btn-primary" onClick={this.handleApplyModes}>
                Применить
              </button>
            </div>
          </div>
        </div>
      </div>
    )
  }

  renderCurrentAccessTable() {
    return (
      <Panel header="Текущие доступы" key="current_access_panel">
        <div className="table-responsive">
          <table className="table table-sm" style={{ tableLayout: 'fixed' }}>
            <thead>
              <tr>
                <th>Посетитель</th>
                <th className="text-wrap" style={{ width: '20%' }}>Цель посещения</th>
                <th>К кому</th>
                <th>Начало действия</th>
                <th>Окончание действия</th>
                <th>В составе группы</th>
                <th>Режимы доступа</th>
              </tr>
            </thead>
            <tbody>
              {this.state.activeAccesses.length === 0 ? (
                <tr>
                  <td colSpan={6} className="text-center text-muted">
                    Нет действующих доступов
                  </td>
                </tr>
              ) : (
                this.state.activeAccesses.map((row) => (
                  <tr key={row.id}>
                    <td>{row.visitor_name || '—'}</td>
                    <td>{row.visit_purpose || '—'}</td>
                    <td>{row.to_user || '—'}</td>
                    <td>{row.start_datetime ? formatDateTime(row.start_datetime) : '—'}</td>
                    <td>{row.end_datetime ? formatDateTime(row.end_datetime) : '—'}</td>
                    <td>{row.object_group_name}</td>
                    <td>{row.modes || '—'}</td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </Panel>
    )
  }

  renderFormAttr(attr, horizontal) {
    if (attr.name === 'approved_accesses_placeholder') return null
    return super.renderFormAttr(attr, horizontal)
  }

  // Дополнительный контент в группу формы
  renderFormGroupInclude(item, position) {
    const tabTitle = item[0]
    const groupTitle = item[1]
    // Блок "Режимы" на вкладке "Режимы" (группа "Режимы")
    if (tabTitle === 'Режимы' && position === 'bottom') {
      if (this.isNewCard()) {
        return null
      }
      return this.renderModesTable()
    }

    if (tabTitle === 'Текущие доступы' && position === 'bottom') {
      return (
        <React.Fragment key="decision_by_request_block">
          {this.renderCurrentAccessTable()}
        </React.Fragment>
      )
    }

    return null
  }

  renderModals() {
    const modals = super.renderModals ? super.renderModals() : []
    return [
      ...modals,
      this.renderModesModal(),
    ]
  }

  // Переопределяем renderContentRight чтобы скрыть блок "Файлы"
  renderContentRight() {
    if(this.object_id === 0) {
      return []
    }

    // Возвращаем только комментарии, без блока "Файлы" и без renderInfo()
    return [
      this.renderComments(),
    ]
  }
}

export default wrapView(ModelView, (state) => stateToPropsSigur(state, PROJECT_NAME))
